import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ExtraLargeTitle, MediumLightTitle, Theme } from '@indigo-ag/component-module';
import React from 'react';
import { Link } from 'react-router-dom';

import { createStylesHook, environmentIndicator } from 'shared';

const useStyles = createStylesHook<Theme, { outerContainerMarginTop: number }>((theme: Theme) => ({
  outerContainer: props => ({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: '0 16px',
    paddingBottom: 16,
    width: '100%',
    marginTop: props.outerContainerMarginTop,
    [theme.breakpoints.up('md')]: {
      paddingBottom: 40,
      paddingLeft: 40,
      paddingRight: 40,
      maxWidth: 1500
    }
  })
}));

interface Props {
  title: string;
  subtitle?: string;
  contentRight?: JSX.Element;
  backLink?: string;
  backLinkLabel?: string;
  /**
   * If `true`, display `contentRight` immediately after the header, as opposed to right-justified. Defaults to `false`.
   */
  displayContentRightAfterHeader?: boolean;
}

export const NewPage: React.FunctionComponent<Props> = ({
  contentRight,
  title,
  subtitle,
  children,
  backLink,
  backLinkLabel,
  displayContentRightAfterHeader = false
}) => {
  /**
   * Styles
   */
  const classes = useStyles({ outerContainerMarginTop: environmentIndicator === 'staging' ? 30 : 0 });

  return (
    <div className={classes.outerContainer}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: displayContentRightAfterHeader ? 'end' : 'center',
          margin: '24px 0 14px'
        }}
      >
        <div style={{ flex: displayContentRightAfterHeader ? 'none' : 1 }}>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {!!backLink ? (
              <Link
                to={backLink}
                style={{ display: 'flex', alignItems: 'center', marginBottom: 16, width: 'max-content' }}
              >
                <FontAwesomeIcon icon={faChevronLeft} size="xs" />
                <span style={{ marginLeft: 8 }}>{backLinkLabel || 'Go Back'}</span>
              </Link>
            ) : null}
            <ExtraLargeTitle className="text-transform-capitalize" style={{ fontWeight: 300 }}>
              {title}
            </ExtraLargeTitle>
            {!!subtitle && <MediumLightTitle>{subtitle}</MediumLightTitle>}
          </div>
        </div>
        {!!contentRight ? <div>{contentRight}</div> : null}
      </div>
      <div>{children}</div>
    </div>
  );
};
